const sushmithaUrl = new URL('../assets/sushmitha.jpg', import.meta.url).toString();
const sakshiUrl = new URL('../assets/sakshi.jpg', import.meta.url).toString();

const founders = [
  {
    image: sushmithaUrl,
    name: 'CA Sushmitha Prabhu',
    role: 'Founding Partner',
    qual: 'CA(India), DISA, CPA(US)',
    bio: `CA Sushmitha Prabhu specializes in delivering strategic financial, audit, and compliance solutions tailored to today's dynamic business environment. With over 8 years of professional experience, including Big4 exposure, she works with a diverse portfolio of clients — from individuals to startups & established enterprises.

Her areas of expertise include Direct Tax Advisory for Individuals, Firms and Corporates, NRI Tax Consultancy, US Tax and Book-Keeping & Startup Advisory.

Prior to starting this firm, she worked in the International Taxation & Transfer Pricing wing of EY India.`,
    specialisations: ['Direct Tax', 'NRI Tax', 'US Tax & Bookkeeping'],
  },
  {
    image: sakshiUrl,
    name: 'CA Sakshi Mallya',
    role: 'Founding Partner',
    qual: 'CA(India), DISA, GST Certification',
    bio: `With over 8 years of post-qualification experience, CA Sakshi Mallya has worked with clients across industries including manufacturing, retail, educational institutions, healthcare and technology.

Her areas of expertise include Indirect Taxation (GST), Audits, Due Diligence & MIS reporting. She also works as Virtual CFO for companies and delivers practical, tailor-made solutions.

Prior to starting this firm, she worked in the International Taxation & Transfer Pricing wing of EY India.`,
    specialisations: ['GST Advisory', 'Audit & Assurance', 'Virtual CFO'],
  },
];

export function Team() {
  return (
    <section className="team" id="team">
      <div className="section-header">
        <p className="section-eyebrow">The People Behind the Work</p>
        <h2 className="section-title">Meet our<br /><em>founders</em></h2>
      </div>
      <div className="team__grid">
        {founders.map((f) => (
          <div className="team-card" key={f.name}>
            <div className="team-card__photo">
              <img src={f.image} alt={f.name} className="team-card__img" />
            </div>
            <div className="team-card__body">
              <div className="team-card__header">
                <div>
                  <h3 className="team-card__name">{f.name}</h3>
                  <p className="team-card__role">{f.role}</p>
                </div>
                <span className="team-card__qual">{f.qual}</span>
              </div>
              <p className="team-card__bio" style={{ whiteSpace: 'pre-line' }}>{f.bio}</p>
              <div className="team-card__tags">
                {f.specialisations.map((s) => (
                  <span className="team-card__tag" key={s}>{s}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
